"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseWebpackManifest = void 0;
var editor_elements_conventions_1 = require("@wix/editor-elements-conventions");
var RegistryError_1 = require("../errors/RegistryError");
var assets_1 = require("../toolbox/assets");
var libraryManifestBuilder_1 = require("./builders/libraryManifestBuilder");
var PREFIX_REGEXP = new RegExp(editor_elements_conventions_1.BUNDLE_PREFIX, 'g');
function parseWebpackManifest(library, libraryAssetsPatterns) {
    if (libraryAssetsPatterns === void 0) { libraryAssetsPatterns = []; }
    var libraryBuilder = libraryManifestBuilder_1.createLibraryManifestBuilder({
        topology: library.topology,
    });
    var _a = library.manifest, webpackRuntimeBundleURL = _a["webpack-runtime.js"], hotBundleURL = _a["hot.js"], components = __rest(_a, ['webpack-runtime.js', 'hot.js']);
    if (webpackRuntimeBundleURL) {
        libraryBuilder.addWebpackRuntimeBundle(webpackRuntimeBundleURL);
    }
    if (hotBundleURL) {
        libraryBuilder.addHotBundle(hotBundleURL);
    }
    Object.keys(components).forEach(function (key) {
        /**
         * If webpack cache group is created automatically,
         * its name may includes multiple entries names
         * eb rb_wixui.thunderbolt[Button]~rb_wixui.thunderbolt[Icon]
         */
        var isWebpackCacheGroup = key.match(PREFIX_REGEXP);
        if (isWebpackCacheGroup && isWebpackCacheGroup.length > 1) {
            return;
        }
        var symbols = editor_elements_conventions_1.parseBundleName(key);
        if (symbols === null) {
            return;
        }
        var host = symbols.host, componentName = symbols.componentName, part = symbols.part, id = symbols.id, batch = symbols.batch, extension = symbols.extension;
        /**
         * If bundle format does not match convention rules.
         * `host` should always be always decoded from the bundle name
         */
        if (!host || batch) {
            return;
        }
        var hostBuilder = libraryBuilder.getHostBuilder(host);
        var url = components[key];
        if (assets_1.isJS(extension)) {
            if (!componentName && !part) {
                hostBuilder.addUrl(id, url);
            }
            else if (componentName) {
                var componentBuilder = hostBuilder.getComponentBuilder(componentName);
                if (part) {
                    componentBuilder.addPart(id, part, url);
                }
                else {
                    componentBuilder.addUrl(id, url);
                }
            }
            else {
                throw RegistryError_1.createInternalException();
            }
        }
        else if (assets_1.isCSS(extension)) {
            if (!componentName && !part) {
                hostBuilder.addStyleAsset(url);
            }
            else if (componentName) {
                var componentBuilder = hostBuilder.getComponentBuilder(componentName);
                componentBuilder.addStyleAsset(url, part);
            }
            else {
                throw RegistryError_1.createInternalException();
            }
        }
    });
    libraryAssetsPatterns.forEach(function (_a) {
        var type = _a.type, pattern = _a.pattern;
        Object.keys(library.manifest).forEach(function (id) {
            var url = library.manifest[id];
            if (pattern.test(id)) {
                var extension = assets_1.getExtension(url);
                libraryBuilder.addLibraryAsset(url, type, extension);
            }
        });
    });
    return libraryBuilder.build();
}
exports.parseWebpackManifest = parseWebpackManifest;
//# sourceMappingURL=parseWebpackManifest.js.map